//抖音广告审核处理

// DYAdUtil = xClass("DYAdUtil")
// DYAdUtil.RATIO = 0.4;
// DYAdUtil.isOpen = function () {
//     let pf = isWechatGameEnv() ? mini.getPlatform() : META.platform
//     if (pf == MiniPlatform.tt) {
//         return true;
//     }
//     return false;
// }
// // 修改按钮icon属性
// DYAdUtil.modifyIconAttribute = function (icon, btn_node, data) {
//     if (!this.isOpen()) return;
//     icon.setSpriteFrame(cc.spriteFrameCache.getSpriteFrame("commonLib/icon_ad.png"));
//     let targetH = btn_node.height * DYAdUtil.RATIO;
//     let new_scale = targetH / icon.height;
//     icon.scale = new_scale;
//     if (data && data.pos) {
//         icon.setPosition(data.pos)
//     }
// }

// DYAdUtil.showAdSecondConfirmPanel = function (cb) {
//     if (!this.isOpen()) {
//         if (cb) cb();
//         return;
//     }

//     var AdSecondConfirmPanel = require("clover/panel/component/AdSecondConfirmPanel")
//     let panel = AdSecondConfirmPanel.create(cb)
//     panel.popup(true)
// }
DYAdUtil = {
    ratio: 0.4,
    // 
    isOpen() {
        // return false;
        // let pf = isWechatGameEnv() ? mini.getPlatform() : META.platform
        // cc.log("[DYAdUtil] DYAdUtil isOpen pf ",pf);
        // if (pf == "douyin_game" || pf == "wechatgame") {
        //     return true;
        // }
        return true;
    },
    // 修改按钮icon属性
    modifyIconAttribute(icon, btn_node, data) {
        if (!this.isOpen()) return;
        icon.setSpriteFrame(cc.spriteFrameCache.getSpriteFrame("commonLib/icon_ad.png"));
        let targetH = btn_node.height * this.ratio;
        let new_scale = targetH / icon.height;
        icon.scale = new_scale;
        if (data && data.pos) {
            icon.setPosition(data.pos)
        }
    },
    // 给按钮添加广告icon
    addAdIcon(btn_node) {
        let icon_ad = cc.Sprite.createWithSpriteFrameName("commonLib/icon_ad.png");
        let targetH = btn_node.height * this.ratio;
        let new_scale = targetH / icon_ad.height;
        icon_ad.scale = new_scale;
        btn_node.addChild(icon_ad);
        return icon_ad;
    },
    // 隐藏视频icon
    hideVideoIcon(icon) {
        if (!this.isOpen()) return;
        icon.opacity = 0;
        icon.setVisible(false)
    },
    // 展示二级确认弹框
    showAdSecondConfirmPanel(cb,cancelCb) {
        if (!this.isOpen()) {
            if (cb) cb();
            return;
        }
        if(this.busy){
            return;
        }
        this.busy = true;
        let onResLoad = () => {
            this.busy = false;
            let panel = AdSecondConfirmPanel.create(cb,cancelCb)
            panel.popup(true)
        }
        let onFail = () => {
            this.busy = false;
            if (cb) cb();//资源加载失败 直接走回调
        }
    
        var AdSecondConfirmPanel = require("clover/panel/component/AdSecondConfirmPanel")
        AdSecondConfirmPanel.preloadRes(onResLoad, onFail);
  
    },
    // 修改按钮size 
    modifyBtnSize(btn,size) {
        if (!this.isOpen()) return;
        btn.scale = 1;
        btn.setContentSize(size)
        if (btn && btn.getChildByName("normal")){
            btn.getChildByName("normal").setContentSize(size)
            btn.getChildByName("normal").scale = 1;
        }
        if (btn && btn.getChildByName("click")){
            btn.getChildByName("click").setContentSize(size)
            btn.getChildByName("click").scale = 1;
        }
        if (btn && btn.getChildByName("disabled")){
            btn.getChildByName("disabled").setContentSize(size)
            btn.getChildByName("disabled").scale = 1;
        }
    },
    
    addPreloadResList(onSuccess){
        let RES = table(
            "font/zzgftongxin_40_greenstroke.png",
            "font/zzgftongxin_40_greenstroke.fnt",
            "font/zzgftongxin_40_brownstroke.png",
            "font/zzgftongxin_40_brownstroke.fnt",
        )
        preloadWithLoading(RES, onSuccess, onSuccess, onSuccess, false)
        // preloadWithLoadingPromise(RES, false);
    },

    createBtn(data,is_have_ad_icon,cb) {
        // 190 116
        let txt = data.txt || "";
        let size = data.size || cc.size(310,120);
        let type = data.type || 1;//1 绿色 2棕色

        let bg_frame_path = "commonLib/lib_btn_green_normal.png";
        let label_path = "font/zzgftongxin_40_greenstroke.fnt";
        if (type == 2){
            bg_frame_path = "commonLib/lib_btn_orange_normal.png";
            label_path = "font/zzgftongxin_40_brownstroke.fnt";
        }


        let btn = ccui.Scale9Sprite.createWithSpriteFrameName(bg_frame_path, cc.rect(95, 50, 10, 10))
        btn.setContentSize(size)
        let offset = 0;
        if (is_have_ad_icon){
            let icon_ad = cc.Sprite.createWithSpriteFrameName("commonLib/icon_ad.png");
            icon_ad.setPosition(icon_ad.width/2 + 18 ,btn.height/2 + 10);
            btn.addChild(icon_ad)
            DYAdUtil.modifyIconAttribute(icon_ad,btn,{
            });
            offset = icon_ad.width/2;
        }
        this.addPreloadResList(()=>{
            let btn_label = cc.LabelBMFont.create(txt, label_path)
            btn.addChild(btn_label)
            let p = cc.p(btn.width/2 + offset,btn.height/2 + 5);
            btn_label.setPosition(p);
        });
        quickBuildBtn(btn, UIGroupButton, PushBounceAnim, () => {
            if (cb) cb();
        }, true);
        return btn
    }

};
module.exports = DYAdUtil;